const getProductUpsellVariantProperties = (variantData = {}) => {
  const properties = {}
  const isPreorder = !variantData.preorderExcluded && variantData.continueSelling && variantData.inventoryQuantity <= 0
  const deliveryStatus = `${variantData.deliveryStatus || ''}`.trim().toLowerCase()

  if (isPreorder) {
    properties.Type = 'Pre-order'
    properties._purchase_type = 'NM-preorder'
    const preorderTag = `${variantData.preorderTag || ''}`.trim()
    if (preorderTag) properties._preorder_tag = preorderTag
  }

  if (deliveryStatus.includes('international')) {
    properties._delivery_status = 'international'
  }

  return properties
}

if (!customElements.get('product-upsells')) {
  class ProductUpsells extends HTMLElement {
    constructor() {
      super()

      this.selectedUpsells = []
      this.handleClick = this.handleClick.bind(this)
      this.handleChange = this.handleChange.bind(this)
      this.handleVariantChange = this.handleVariantChange.bind(this)
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick)
      this.addEventListener('change', this.handleChange)
      this.addEventListener('product-upsell:variant-change', this.handleVariantChange)
      this.syncInitialSelectedUpsells()
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick)
      this.removeEventListener('change', this.handleChange)
      this.removeEventListener('product-upsell:variant-change', this.handleVariantChange)
    }

    handleClick(event) {
      const upsellItem = event.target.closest('[data-product-upsell-item]')

      if (!upsellItem || !this.contains(upsellItem)) return
      if (this.isInteractiveUpsellElement(event.target)) return

      this.openPopup(upsellItem)
    }

    isInteractiveUpsellElement(target) {
      return Boolean(
        target.closest('[data-product-upsell-checkbox]') ||
        target.closest('.product-upsells__checkmark') ||
        target.closest('.product-upsells__variant-picker')
      )
    }

    handleChange(event) {
      const checkbox = event.target.closest('[data-product-upsell-checkbox]')

      if (!checkbox || !this.contains(checkbox)) return

      const upsellData = this.getUpsellDataFromCheckbox(checkbox)

      this.syncSelectedUpsell(upsellData)
    }

    handleVariantChange(event) {
      this.updateSelectedUpsellVariant(event.detail)
    }

    syncInitialSelectedUpsells() {
      this.querySelectorAll('[data-product-upsell-checkbox]:checked').forEach((checkbox) => {
        this.syncSelectedUpsell(this.getUpsellDataFromCheckbox(checkbox))
      })
    }

    getUpsellDataFromCheckbox(checkbox) {
      const upsellItem = checkbox.closest('[data-product-upsell-item]')
      const variantData = this.getSelectedVariantData(upsellItem)

      return {
        handle: checkbox.dataset.handle,
        variantId: variantData.variantId || checkbox.value,
        isChecked: checkbox.checked,
        properties: this.getVariantProperties(variantData)
      }
    }

    getSelectedVariantData(upsellItem) {
      if (!upsellItem) return {}

      const select = upsellItem.querySelector('[data-size-selector]')
      const selectedOption = select?.options[select.selectedIndex]
      const variantInput = selectedOption || upsellItem.querySelector('[name="variant_id"]')

      return this.getVariantDataFromElement(variantInput)
    }

    getVariantDataFromElement(element) {
      if (!element) return {}

      return {
        variantId: element.value,
        inventoryQuantity: Number(element.dataset.variantQuantity || 0),
        continueSelling: element.dataset.variantContinueSelling === 'true',
        preorderExcluded: element.dataset.preorderExcluded === 'true',
        preorderTag: `${element.dataset.preorderTag || ''}`.trim(),
        deliveryStatus: `${element.dataset.deliveryStatus || ''}`.trim().toLowerCase()
      }
    }

    getVariantProperties(variantData) {
      return getProductUpsellVariantProperties(variantData)
    }

    syncSelectedUpsell(upsellData) {
      if (!upsellData.handle || !upsellData.variantId) return

      const upsellIndex = this.selectedUpsells.findIndex((selectedUpsell) => {
        return selectedUpsell.handle === upsellData.handle
      })

      if (upsellData.isChecked) {
        if (upsellIndex === -1) {
          this.addSelectedUpsell(upsellData)
        } else {
          this.updateSelectedUpsell(upsellIndex, upsellData)
        }
      } else if (upsellIndex !== -1) {
        this.removeSelectedUpsell(upsellIndex)
      }

      this.emitSelectedUpsells()
    }

    addSelectedUpsell(upsellData) {
      this.selectedUpsells.push({
        handle: upsellData.handle,
        variant_id: upsellData.variantId,
        properties: upsellData.properties || {}
      })
    }

    updateSelectedUpsell(upsellIndex, upsellData) {
      this.selectedUpsells[upsellIndex] = {
        handle: upsellData.handle,
        variant_id: upsellData.variantId,
        properties: upsellData.properties || {}
      }
    }

    updateSelectedUpsellVariant(upsellData) {
      if (!upsellData?.handle || !upsellData?.variant_id) return

      const upsellIndex = this.selectedUpsells.findIndex((selectedUpsell) => {
        return selectedUpsell.handle === upsellData.handle
      })

      if (upsellIndex === -1) return

      this.updateSelectedUpsell(upsellIndex, {
        handle: upsellData.handle,
        variantId: upsellData.variant_id,
        properties: upsellData.properties || {}
      })
      this.emitSelectedUpsells()
    }

    removeSelectedUpsell(upsellIndex) {
      this.selectedUpsells.splice(upsellIndex, 1)
    }

    emitSelectedUpsells() {
      this.dispatchEvent(new CustomEvent('product-upsells:change', {
        bubbles: true,
        detail: {
          items: this.selectedUpsells.map((selectedUpsell) => {
            return {
              handle: selectedUpsell.handle,
              variant_id: selectedUpsell.variant_id,
              properties: selectedUpsell.properties || {}
            }
          })
        }
      }))
    }

    openPopup(upsellItem) {
      const template = upsellItem.querySelector('[data-product-upsell-popup-template]')
      const popup = this.getPopup()

      if (!template || !popup || typeof popup.open !== 'function') return

      popup.open(template)
    }

    getPopup() {
      const section = this.closest('.shopify-section')

      return section?.querySelector('[data-product-upsell-popup]') ||
        document.querySelector('[data-product-upsell-popup]')
    }
  }

  customElements.define('product-upsells', ProductUpsells);
}

if (!customElements.get('product-upsells-popup')) {
  class ProductUpsellsPopup extends HTMLElement {
    constructor() {
      super()

      this.handleEsc = this.handleEsc.bind(this)
      this.handleClick = this.handleClick.bind(this)
      this.handleCartDrawerOpen = this.handleCartDrawerOpen.bind(this)
      this.lockBodyScroll = this.lockBodyScroll.bind(this)
      this.unlockBodyScroll = this.unlockBodyScroll.bind(this)
      this.abortController = null
      this.cartDrawerOpenUnsubscriber = null
      this.openScrollY = 0
    }

    connectedCallback() {
      this.content = this.querySelector('[data-product-upsell-popup-content]')
      this.addEventListener('click', this.handleClick)

      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.openCartDrawer) {
        this.cartDrawerOpenUnsubscriber = window.MinimogEvents.subscribe(
          window.MinimogTheme.pubSubEvents.openCartDrawer,
          this.handleCartDrawerOpen
        )
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick)
      this.cartDrawerOpenUnsubscriber?.()
      window.removeEventListener('keydown', this.handleEsc)
      this.abortProductRequest()
      this.unlockBodyScroll()
    }

    open(template) {
      if (!this.content || !template) return

      this.openScrollY = window.scrollY || window.pageYOffset || 0
      this.lockBodyScroll()
      this.abortProductRequest()
      this.content.innerHTML = ''
      this.content.appendChild(template.content.cloneNode(true))
      this.hidden = false
      this.classList.add('is-open')
      this.initSliders()

      window.addEventListener('keydown', this.handleEsc)
    }

    close() {
      this.abortProductRequest()
      this.classList.remove('is-open')
      this.hidden = true

      if (this.content) {
        this.content.innerHTML = ''
      }

      this.unlockBodyScroll()
      window.removeEventListener('keydown', this.handleEsc)
    }

    lockBodyScroll() {
      document.body.classList.add('product-upsells-popup-open')
      document.body.style.top = `-${this.openScrollY}px`
    }

    unlockBodyScroll() {
      const targetScrollY = this.openScrollY || 0
      const previousScrollBehavior = document.documentElement.style.scrollBehavior

      document.documentElement.style.scrollBehavior = 'auto'
      document.body.classList.remove('product-upsells-popup-open')
      document.body.style.removeProperty('top')
      window.scrollTo(0, targetScrollY)
      window.requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = previousScrollBehavior
      })
    }

    handleClick(event) {
      const colorButton = event.target.closest('[data-upsell-color-button]');

      if (colorButton) {
        event.preventDefault();
        this.loadProduct(colorButton.dataset.productHandle);
        return;
      }

      if (event.target.closest('[data-product-upsell-popup-close]')) {
        this.close();
      }
    }

    async loadProduct(handle) {
      if (!handle || !this.content) return;

      this.abortProductRequest()
      const controller = new AbortController()
      this.abortController = controller

      try {
        const response = await fetch(
          `/products/${handle}?section_id=upsell-modal-template`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          throw new Error('Failed to load upsell product');
        }

        const html = await response.text();

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        const template = wrapper.querySelector(
          '[data-product-upsell-popup-template]'
        );

        if (!template) {
          console.error('Template not found');
          return;
        }

        this.content.innerHTML = '';
        this.content.appendChild(
          template.content.cloneNode(true)
        );
        this.initSliders()
      } catch (error) {
        if (error.name === 'AbortError') return;

        console.error(error);
      } finally {
        if (this.abortController === controller) {
          this.abortController = null
        }
      }
    }

    abortProductRequest() {
      if (!this.abortController) return

      this.abortController.abort()
      this.abortController = null
    }

    initSliders(attempt = 0) {
      if (!this.content) return

      const sliders = this.content.querySelectorAll('[data-slider-selector]')
      const SwiperClass = window.Swiper || window.MinimogLibs?.Swiper

      if (!sliders.length) return

      if (!SwiperClass) {
        if (attempt < 10) {
          window.setTimeout(() => this.initSliders(attempt + 1), 100)
        }
        return
      }

      sliders.forEach((slider) => {
        if (slider.swiper) return

        let config = {}

        try {
          config = JSON.parse(slider.dataset.config || '{}')
        } catch (error) {
          console.error('Error parsing upsell popup slider configuration:', error)
        }

        if (config.navigation) {
          const nextEl = this.getScopedSliderElement(slider, config.navigation.nextEl)
          const prevEl = this.getScopedSliderElement(slider, config.navigation.prevEl)

          if (nextEl || prevEl) {
            config.navigation = {
              ...config.navigation,
              nextEl,
              prevEl
            }
          } else {
            delete config.navigation
          }
        }

        window.requestAnimationFrame(() => {
          new SwiperClass(slider, config)
        })
      })
    }

    getScopedSliderElement(slider, selector) {
      if (!selector || typeof selector !== 'string') return selector

      return slider.closest('.product-upsells-popup__product')?.querySelector(selector) ||
        this.querySelector(selector)
    }

    handleEsc(event) {
      if (event.key === 'Escape') {
        this.close()
      }
    }

    handleCartDrawerOpen() {
      if (this.hidden) return

      this.close()
    }
  }

  customElements.define('product-upsells-popup', ProductUpsellsPopup);
}

if (!customElements.get('product-upsells-size-selector')) {
  class ProductUpsellsSizeSelector extends HTMLElement {
    constructor() {
      super()

      this.select = this.querySelector('[data-size-selector]')
      this.handleChange = this.handleChange.bind(this)
    }

    connectedCallback() {
      this.select?.addEventListener('change', this.handleChange)
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handleChange)
    }

    handleChange() {
      if (!this.select) return

      const checkbox = this.closest('[data-product-upsell-item]')?.querySelector('[data-product-upsell-checkbox]')
      const selectedOption = this.select.options[this.select.selectedIndex]
      const variantData = {
        variantId: selectedOption?.value || this.select.value,
        inventoryQuantity: Number(selectedOption?.dataset.variantQuantity || 0),
        continueSelling: selectedOption?.dataset.variantContinueSelling === 'true',
        preorderExcluded: selectedOption?.dataset.preorderExcluded === 'true',
        preorderTag: `${selectedOption?.dataset.preorderTag || ''}`.trim(),
        deliveryStatus: `${selectedOption?.dataset.deliveryStatus || ''}`.trim().toLowerCase()
      }

      if (checkbox) {
        checkbox.value = this.select.value
      }

      this.dispatchEvent(new CustomEvent('product-upsell:variant-change', {
        bubbles: true,
        detail: {
          handle: this.dataset.handle,
          variant_id: variantData.variantId,
          properties: getProductUpsellVariantProperties(variantData)
        }
      }))
    }
  }

  customElements.define('product-upsells-size-selector', ProductUpsellsSizeSelector);
}
